import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {UserReport} from '../types';
import {v8nSchemaOfGetReportsResponse} from './backendSchemas';
import {GetReportsResponse} from './backendTypes';
import {mapUserReportFromBackend} from './dataMappers';

export interface GetReportsParams extends GetListParams {
  processed?: boolean;
}

export const getReports = async ({
  page,
  pageSize,
  processed,
}: GetReportsParams = {}): Promise<GetListOutput<UserReport>> => {
  const response = await axi.get<GetReportsResponse>('/admin/reports', {
    params: {
      page,
      per_page: pageSize,
      processed,
    },
  });

  validateData(response.data, v8nSchemaOfGetReportsResponse, 'getReports');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = response.data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapUserReportFromBackend(item)),
  };
};

export interface UpdateReportParams {
  reportId: string;
  processed: boolean;
}

export const updateReport = async ({
  reportId,
  processed,
}: UpdateReportParams): Promise<void> => {
  await axi.patch(`/admin/reports/${reportId}`, {processed});
};
